import React from 'react'
import { Typography } from 'antd'
import moment from 'moment'
import styles from './OrderDateTime.module.scss'

interface IOrderDateTimeProps {
  value?: string | Date | null
  inline?: boolean
}

export const OrderDateTime: React.FC<IOrderDateTimeProps> = ({
  value,
  inline = false
}) => {
  const date = moment(value)

  if (inline) {
    return (
      <span className={styles.inline}>
        {date.format('DD.MM.YYYY')} — {date.format('HH:mm')}
      </span>
    )
  }

  return (
    <div className={styles.stacked}>
      <Typography.Text>{date.format('DD.MM.YYYY')}</Typography.Text>
      <Typography.Text type='secondary'>{date.format('HH:mm')}</Typography.Text>
    </div>
  )
}
